export const FRAGMENTS = {
  DATA_ELEMENT: '[data-fb-fragment="facebookBusiness"]',
  FORM_SUBMIT: '[data-fb-fragment="formSubmit"]',
  FORM_USER_DATA_CLIENT_IP_ADDRESS: '[data-fb-fragment="clientIpAddress"]',
  FORM_USER_DATA_CLIENT_USER_AGENT: '[data-fb-fragment="clientUserAgent"]',
  FORM_USER_DATA_EXTERNAL_ID: '[data-fb-fragment="externalId"]'
};

export const HELPED_FRAGMENTS = {
  FORM_SUBMIT_EVENT_INPUT_IDS: '[data-fb-event-input-ids]',
  FORM_SUBMIT_EVENT_NAME: '[data-fb-event-name]',
  FORM_SUBMIT_FORM_ID: '[data-fb-form-id]',
  FORM_SUBMIT_FORM_NAME: '[data-fb-form-name]',
  FORM_SUBMIT_FORM_TEXT: '[data-fb-form-text]',
  FORM_SUBMIT_FORM_REDIRECT_AFTER_SUBMIT: '[data-fb-form-redirect-after-submit]',
  FORM_INPUT_IDENTIFIER: '[data-fb-input-identifier]',
  IP_ADDRESS: '[data-ip-address]',
  WEB_SYSTEM_ID: '[data-web-system-id]'
};

export const EVENT_NAMES = {
  FG_PAGE_VIEW: 'fg_page_view',
  FORM: 'form'
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/enums/enums.js